import React from 'react';
import styled from 'styled-components';
import { FiBook } from 'react-icons/fi';

const SelectContainer = styled.div`
  position: relative;
  min-width: 200px;
  flex: 1;
  
  @media (max-width: 768px) {
    min-width: 150px;
  }
  
  @media (max-width: 640px) {
    min-width: 120px;
  }
  
  @media (max-width: 480px) {
    min-width: 100px;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 40px 12px 16px;
  border: 1px solid var(--border-color);
  border-radius: 0;
  background: var(--background-primary);
  font-size: 16px;
  font-weight: 500;
  color: var(--text-primary);
  cursor: pointer;
  transition: border-color 0.2s ease;
  height: 48px;
  appearance: none;

  &:focus {
    outline: none;
    border-color: var(--primary-color);
    box-shadow: 0 0 0 3px var(--focus-ring);
  }

  &:disabled {
    background: var(--background-secondary);
    color: var(--text-muted);
    cursor: not-allowed;
  }
  
  @media (max-width: 640px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 13px;
  }
  
  @media (max-height: 600px) {
    height: 40px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
  }
  
  @media (max-height: 500px) {
    height: 36px;
    padding: 6px 32px 6px 10px;
    font-size: 14px;
  }
`;

const SelectIcon = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
  pointer-events: none;
  
  @media (max-width: 640px) {
    right: 12px;
  }
  
  @media (max-width: 480px) {
    right: 10px;
  }
  
  @media (max-height: 600px) {
    right: 12px;
  }
  
  @media (max-height: 500px) {
    right: 10px;
  }
`;

export default function CourseSelect({ value, onChange, courses = [], disabled = false, placeholder = "Select course..." }) {
  return (
    <SelectContainer>
      <Select
        value={value || ''}
        onChange={(e) => onChange(parseInt(e.target.value) || null)}
        disabled={disabled}
      >
        <option value="">{placeholder}</option>
        {courses.map(course => (
          <option key={course.id} value={course.id}>
            {course.code} - {course.name}
          </option>
        ))}
      </Select>
      <SelectIcon>
        <FiBook size={16} />
      </SelectIcon>
    </SelectContainer>
  );
}
